import { styled } from '@mui/material/styles';
import { TextField, Paper, Icon } from '@mui/material';

interface StyledDatePickerTextFieldProps {
  fontSize?: string;
  color?: string;
  fontWeight?: string;
  width?: string;
  height?: string;
  borderColor?: string;
  hasError?: boolean;
}

export const StyledDatePickerTextField = styled(TextField, {
  shouldForwardProp: (prop) =>
    prop !== 'fontSize' &&
    prop !== 'color' &&
    prop !== 'fontWeight' &&
    prop !== 'width' &&
    prop !== 'height' &&
    prop !== 'borderColor' &&
    prop !== 'hasError',
})<StyledDatePickerTextFieldProps>(
  ({
    fontSize = '10px',
    color = 'var(--primary-navy)',
    fontWeight = '400',
    width = '150px',
    height = '28px',
    borderColor = 'var(--hover-white)',
    hasError = false,
  }) => ({
    width: width,
    height: height,
    overflow: 'hidden',

    '& .MuiOutlinedInput-root': {
      height: height,
      minHeight: height,
      backgroundColor: 'var(--text-bg)',
      border: 'none',
      borderRadius: '4px',
      color: 'var(--primary-navy)',

      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'var(--primary-blue)',
      },

      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'var(--primary-blue)',
      },

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: hasError ? 'var(--error)' : borderColor,
      },
    },

    '& .MuiInputBase-input': {
      fontFamily: 'Outfit',
      fontSize: fontSize,
      color: color,
      fontWeight: fontWeight,
      padding: '8px 12px',

      '&::placeholder': {
        color: 'var(--primary-navy)',
        opacity: 1,
      },
    },

    '& input': {
      fontFamily: 'Outfit',
      fontSize: fontSize,
    },
  })
);

export const StyledDatePickerPaper = styled(Paper)({
  marginTop: 8,
  borderRadius: 16,
  width: '320px',
  height: '325px',
  fontFamily: 'Outfit',
  fontWeight: 400,
  color: 'var(--primary-navy)',
  overflow: 'hidden',
  paddingBottom: 8,
});

export const CalendarIcon = styled(Icon)({
  fontSize: '14px',
});
